<template>
  <div class="col-9 p-4 h-100 overflow-auto">
    <div class="w-75 m-auto d-flex flex-column">
      <h5>{{ $t('frame.passwordChange.title') }}</h5>
      <div class="my-3">
        <h6 class="font-size-md">
          <span class="flex-grow-1">{{ $t('frame.passwordChange.form.oldPassword.label') }}</span>
        </h6>
        <div class="input-icon input-icon-sm">
          <b-form-input
            v-model="password.old"
            :placeholder="$t('register.password.placeholder')"
            :state="oldValid ? null : false"
            size="sm"
            class="rounded-pill pr-5"
            :type="show.old ? 'text' : 'password'"
          />
          <div class="input-icon-group">
            <a href="#" tabindex="-1" @click="show.old = !show.old">
              <span class="material-icons font-size-base text-secondary mr-3">{{ show.old ? 'visibility_off' : 'visibility' }}</span>
            </a>
          </div>
          <div v-if="!oldValid" class="invalid-feedback">
            {{ error.old }}
          </div>
        </div>
      </div>
      <div class="my-3">
        <h6 class="font-size-md">
          <span class="flex-grow-1">{{ $t('frame.passwordChange.form.newPassword.label') }}</span>
        </h6>
        <div class="input-icon input-icon-sm">
          <b-form-input
            v-model="password.new"
            :placeholder="$t('register.password.placeholder')"
            :state="newValid ? null : false"
            size="sm"
            class="rounded-pill pr-5"
            :type="show.new ? 'text' : 'password'"
          />
          <div class="input-icon-group">
            <a href="#" tabindex="-1" @click="show.new = !show.new">
              <span class="material-icons font-size-base text-secondary mr-3">{{ show.new ? 'visibility_off' : 'visibility' }}</span>
            </a>
          </div>
          <div v-if="!newValid" class="invalid-feedback">
            {{ error.new }}
          </div>
          <div class="mt-1 font-size-sm text-gray600">
            {{ $t('register.password.hint') }}
          </div>
        </div>
      </div>
      <div class="my-3">
        <h6 class="font-size-md">
          <span class="flex-grow-1">{{ $t('frame.passwordChange.form.confirmPassword.label') }}</span>
        </h6>
        <div class="input-icon input-icon-sm">
          <b-form-input
            v-model="password.newConfirm"
            :placeholder="$t('register.confirmPassword.placeholder')"
            :state="newConfirmValid ? null : false"
            size="sm"
            class="rounded-pill pr-5"
            :type="show.newConfirm ? 'text' : 'password'"
          />
          <div class="input-icon-group">
            <a href="#" tabindex="-1" @click="show.newConfirm = !show.newConfirm">
              <span class="material-icons font-size-base text-secondary mr-3">{{ show.newConfirm ? 'visibility_off' : 'visibility' }}</span>
            </a>
          </div>
          <div v-if="!newConfirmValid" class="invalid-feedback">
            {{ error.newConfirm }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    error: {
      type: Object
    }
  },
  data() {
    return {
      password: this.value,
      show: {
        old: false,
        new: false,
        newConfirm: false
      }
    };
  },
  computed: {
    oldValid() {
      return (this.error.old || '') === '';
    },
    newValid() {
      return (this.error.new || '') === '';
    },
    newConfirmValid() {
      return (this.error.newConfirm || '') === '';
    }
  },
  watch: {
    password: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
  }
};
</script>
